import { find } from "lodash";

export const FlashType = {
  success: "success",
  error: "error",
} as const;
export type FlashType = (typeof FlashType)[keyof typeof FlashType];

export type Flash = {
  type: FlashType;
  message: string;
  subMessage?: string;
  label?: {
    labelName: string;
    labelUrl: string;
  };
};

const ADD_FLASH = "ADD_FLASH" as const;
const CLEAR_FLASH = "CLEAR_FLASH" as const;

type AddFlashAction = {
  type: typeof ADD_FLASH;
  payload: {
    flash: Flash;
  };
};

const addFlash = (flash: Flash): AddFlashAction => {
  return { type: ADD_FLASH, payload: { flash } };
};

type ClearFlashAction = {
  type: typeof CLEAR_FLASH;
};

const clearFlash = (): ClearFlashAction => {
  return { type: CLEAR_FLASH };
};

export type ActionType = AddFlashAction | ClearFlashAction;

export const actions = {
  addFlash,
  clearFlash,
};

export const actionTypeLiterals = {
  ADD_FLASH,
  CLEAR_FLASH,
};

export type State = {
  flashList: Flash[];
};

export const initialState: State = {
  flashList: [],
};

export const reducer = (state: State, action: ActionType): State => {
  switch (action.type) {
    case ADD_FLASH:
      if (find(state.flashList, action.payload.flash)) {
        return state;
      }
      return {
        ...state,
        flashList: [...state.flashList, action.payload.flash],
      };
    case CLEAR_FLASH:
      return {
        ...state,
        flashList: [],
      };
    default: {
      const undefinedAction: never = action;
      console.error(
        `undefined action is used in flash reducer: ${JSON.stringify(
          undefinedAction
        )}`
      );
      return state;
    }
  }
};
